import { T, F } from './tokens';

interface ChatBubbleProps {
  text: string;
  isNurse?: boolean;
  themeColor?: string;
  label?: string;
  time?: string;
}

export function ChatBubble({ text, isNurse, themeColor, label, time }: ChatBubbleProps) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: isNurse ? 'flex-start' : 'flex-end',
      marginBottom: 12,
    }}>
      {label && (
        <span style={{
          fontSize: 9, fontFamily: F.mono, color: T.textGhost,
          padding: '0 4px', marginBottom: 3,
          background: T.bgInput, borderRadius: T.radius.sm,
        }}>
          {label}
        </span>
      )}
      <div style={{
        maxWidth: isNurse ? '82%' : '78%',
        padding: '10px 14px',
        background: isNurse ? T.bgInput : (themeColor || T.accent),
        color: isNurse ? T.textSoft : '#fff',
        borderRadius: isNurse ? '14px 14px 14px 4px' : '14px 14px 4px 14px',
        fontSize: 13, lineHeight: 1.5, fontFamily: F.body,
        boxShadow: T.shadowSm,
      }}>
        {text}
      </div>
      {time && (
        <span style={{
          fontSize: 9, color: T.textGhost,
          marginTop: 2, padding: '0 4px', fontFamily: F.body,
        }}>
          {time}
        </span>
      )}
    </div>
  );
}
